export const INITIAL_DYNAMIC_ATTRIBUTES = Object.freeze({
  fields: {},
  query: {
    dataType: 'last_published',
  },
  singleLine: true,
  type: 'empty',
});

export const dynamicAttributesFields = {
  events: {
    displayAttendees: true,
    displayCategories: true,
    displayCoverPicture: true,
    displayContent: true,
    displayDate: true,
    displayLocation: true,
    displayOnlineEvent: true,
    displayTitle: true,
  },
  news: {
    displayCategories: true,
    displayContent: true,
    displayCoverPicture: true,
    displayTitle: true,
  },
  topics: {
    displayButtons: true,
    displayCategories: true,
    displayDescription: true,
    displayImage: true,
    displayLocation: true,
    displayNumberOfMembers: true,
    displayTitle: true,
  },
};
